export default "__VITE_ASSET__UVwmW3yx__"